import { Actions } from "../components/buttons/Actions";
import { GenericSwitch } from "../components/elements/Switch";
import { actionsColumn, activeColumn } from "../constants/objects";
import { SORT } from "../constants/strings";
import { useAppContext } from "../context/useAppContext";
import { CategoryForm } from "../forms/CategoryForm";
import { CategoryRow } from "../pages/categories/CategoryRow";
import { numberFormatter } from "../utils/formatter";
import { DeleteData, useFirebase } from "./firebase/useFirebase";

export const useCategories = (data) => {
  const { listenData: getTopMenu, data: topMenu, loading } = useFirebase();
  const { contextData } = useAppContext();

  const categoriesTableData = (data = []) => [
    ...data?.map((item) => {
      const row = {
        component: <CategoryRow parentId={item.id} />,
        onclick: () =>
          contextData.showGlobalDrawer({
            component: <CategoryForm data={item} />,
            title: "Update Category",
          }),
        category_name: item.category_name,
        sort: numberFormatter(item.sort),
        active: (
          <GenericSwitch end checked={item.active} docRef={item.docRef} />
        ),
        actions: (
          <Actions
            actions={[
              {
                action: "Edit",
                click: () =>
                  contextData.showGlobalDrawer({
                    component: <CategoryForm data={item} />,
                    title: "Update Category",
                  }),
              },
              {
                action: "Delete",
                click: () => DeleteData(item.docRef),
                confirm: true,
              },
            ]}
          />
        ),
      };
      return row;
    }),
  ];

  const categoriesTableColumns = () => [
    { id: "category_name", title: "Category", align: "left" },
    { id: SORT },
    activeColumn,
    actionsColumn,
  ];

  return {
    categoriesTableColumns,
    categoriesTableData,
    loading,
    topMenu,
    getTopMenu,
  };
};
